// import React, { useEffect, useState } from "react";
// import Button from "src/components/ui/Button";
// import TableV2 from "src/components/ui/TableV2";
// import { useAppDispatch, useAppSelector } from "src/redux/hooks";
// import * as tenantActions from "src/redux/slices/tenantSlice";
// import AddEditRoleModal from "../modals/AddEditRoleModal";

// interface RolesAndPermissionsTabProps {
//   tenantId: string;
// }

// const RolesAndPermissionsTab: React.FC<RolesAndPermissionsTabProps> = ({
//   tenantId,
// }) => {
//   const dispatch = useAppDispatch();
//   const { tenantRoleList } = useAppSelector((s) => s.tenant);

//   const [open, setOpen] = useState(false);
//   const [editRole, setEditRole] = useState<any>(null);

//   useEffect(() => {
//     if (tenantId)
//       dispatch(tenantActions.getTenantRoleListRequest({ tenantId }));
//   }, [tenantId]);

//   return (
//     <div className="p-4 bg-white rounded-lg shadow-sm">
//       <div className="flex items-center justify-between mb-4">
//         <h2 className="text-lg font-semibold text-gray-800">
//           Roles & Permissions
//         </h2>
//         <Button onClick={() => setOpen(true)}>+ Add Role</Button>
//       </div>

//       <TableV2
//         // loading={tenantRoleList?.loading}
//         columns={[
//           { header: "Role", key: "name" },
//           { header: "Description", key: "description" },
//           {
//             header: "Actions",
//             key: "actions",
//             accessor: (row: any) => (
//               <div className="flex items-center gap-2">
//                 <Button
//                   // size="sm"
//                   variant="outline"
//                   onClick={() => {
//                     setEditRole(row);
//                     setOpen(true);
//                   }}
//                 >
//                   Edit
//                 </Button>
//                 <Button
//                   // size="sm"
//                   variant="outline"
//                   onClick={() => {
//                     setEditRole(row);
//                     setOpen(true);
//                   }}
//                 >
//                   Edit
//                 </Button>
//               </div>
//             ),
//           },
//         ]}
//         data={tenantRoleList?.data?.data}
//       />

//       {open && (
//         <AddEditRoleModal
//           open={open}
//           onClose={() => {
//             setEditRole(null);
//             setOpen(false);
//             dispatch(tenantActions.getTenantRoleListRequest({ tenantId }));
//             dispatch(tenantActions.resetCreateTenantRole());
//             dispatch(tenantActions.resetEditTenantRole());
//           }}
//           existingRole={editRole}
//           tenantId={tenantId}
//         />
//       )}
//     </div>
//   );
// };

// export default RolesAndPermissionsTab;

import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import Button from "src/components/ui/Button";
import TableV2 from "src/components/ui/TableV2";
import * as tenantActions from "src/redux/slices/tenantSlice";
import AddEditRoleModal from "src/components/modals/AddEditRoleModal";
import { Edit2Icon, Trash2 } from "lucide-react";
import { toast } from "react-toastify";
import ConfirmationModal from "../modals/ConfirmationModal";

interface RolesAndPermissionsTabProps {
  tenantId?: string;
  isAdminAuth?: boolean;
}

const RolesAndPermissionsTab: React.FC<RolesAndPermissionsTabProps> = ({
  tenantId,
  isAdminAuth = false,
}) => {
  const dispatch = useAppDispatch();
  const { tenantRoleList, deleteTenantRole } = useAppSelector(
    (state) => state.tenant
  );
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authTenant);
  const [open, setOpen] = React.useState(false);
  const [editRole, setEditRole] = React.useState<any>(null);

  const [deleteRole, setDeleteRole] = useState<any>(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const resolvedTenantId = tenantId || user?.tenantId || "";
  const tenantIdParam = tenantId || undefined;

  useEffect(() => {
    dispatch(
      tenantActions.getTenantRoleListRequest({
        tenantId: tenantIdParam,
        isAdminAuth,
      })
    );
  }, [tenantIdParam, isAdminAuth, dispatch]);

  useEffect(() => {
    if (deleteTenantRole) {
      if (deleteTenantRole?.data?.success) {
        toast.success("Tenant role deleted successfully");
        setOpenDeleteModal(false);
        dispatch(tenantActions.resetDeleteTenantRole());
        dispatch(
          tenantActions.getTenantRoleListRequest({
            tenantId: tenantIdParam,
            isAdminAuth,
          })
        );
      } else if (deleteTenantRole?.error) {
        toast.error("Error while deleting tenant role");
      }
    }
  }, [deleteTenantRole, tenantIdParam, isAdminAuth, dispatch]);

  return (
    <div className="">
      <div className="flex justify-between items-center mb-4">
        {/* <h2 className="text-lg font-semibold">Roles & Permissions</h2> */}
        <Button onClick={() => setOpen(true)}>+ Add Role</Button>
      </div>

      <TableV2
        // loading={loading}
        columns={[
          { header: "Role", key: "name" },
          { header: "Description", key: "description" },
          {
            header: "Actions",
            key: "",
            accessor: ({ row }) =>
              row?.name?.toLocaleLowerCase() === "admin" ? (
                "No Actions"
              ) : (
                <div className="flex items-center gap-4">
                  <button
                    className="flex items-center gap-1 text-blue-600"
                    onClick={() => {
                      setEditRole(row);
                      setOpen(true);
                    }}
                  >
                    <Edit2Icon className="w-4 h-4" /> Edit
                  </button>
                  <button
                    className="flex items-center gap-1 text-red-600"
                    onClick={() => {
                      setDeleteRole(row);
                      setOpenDeleteModal(true);
                    }}
                  >
                    <Trash2 className="w-4 h-4" /> Delete
                  </button>
                </div>
              ),
          },
        ]}
        data={tenantRoleList?.data?.data}
      />

      {open && (
        <AddEditRoleModal
          open={open}
          onClose={() => {
            setEditRole(null);
            setOpen(false);
            dispatch(
              tenantActions.getTenantRoleListRequest({
                tenantId: tenantIdParam,
                isAdminAuth,
              })
            );
            dispatch(tenantActions.resetCreateTenantRole());
            dispatch(tenantActions.resetEditTenantRole());
          }}
          existingRole={editRole}
          tenantId={tenantId}
          isAdminAuth={isAdminAuth}
        />
      )}

      {openDeleteModal && (
        <ConfirmationModal
          open={openDeleteModal}
          message="Are you sure, you want to delete this entry?"
          onConfirm={() => {
            dispatch(
              tenantActions.deleteTenantRoleRequest({
                id: deleteRole?._id,
                isAdminAuth,
              })
            );
          }}
          onCancel={() => {
            setOpenDeleteModal(false);
          }}
        />
      )}
    </div>
  );
};

export default RolesAndPermissionsTab;
